import { FC } from 'react';
import { Icon, TIconNames } from 'components/Base/Icon';
import { Colors } from 'core/CssVariables';
import { useGetAdminProfileQuery } from 'redux/apiSlice/profile.slice';
import { TProfilePictureProps } from './ProfilePicture.types';
import Image from 'components/Base/Image';

const ProfilePicture: FC<TProfilePictureProps> = ({ onClick }) => {
  const { data: profile } = useGetAdminProfileQuery();

  if (!profile?.profilePicture) {
    return (
      <Icon
        icon={TIconNames.PROFILE_ICON}
        color={Colors.Black}
        onClick={onClick}
      />
    );
  }

  return (
    <Image
      src={profile.profilePicture}
      alt="Profile picture"
      shape="circle"
      width={38}
      onClick={onClick}
    />
  );
};

export default ProfilePicture;
